<template>
  <v-dialog
    :value="dialog"
    @input="onClose"
    max-width="800px">
    <v-card>
      <v-card-title class="headline">
        <v-layout>
          <v-flex>
            <template >
              <span>{{ $t('message.sendMessageAllClients') }}</span>
            </template>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-layout align-center>
              <v-flex>
                <v-chip
                  :value="true"
                  @input="removeImage"
                  class="mb-4"
                  close
                  color="primary"
                  outline
                  v-if="!!imageFile"
                >{{ imageFile.name }}</v-chip>
              </v-flex>
              <!-- <v-flex>
                <ValidationProvider
                  name="image"
                  ref="myInput"
                  rules="required"
                  v-slot="{ validate, errors}">
                  <v-input :error-messages="errors">
                    <v-btn
                      @click="$refs.imageInput.click()"
                      color="primary">
                      <v-icon class="mx-2">zmdi-plus</v-icon>
                      <span>{{ $t('message.addImage') }}</span>
                    </v-btn>
                    <input
                      @change="saveImage($event) || validate($event)"
                      key="send-image"
                      ref="imageInput"
                      style="display: none;"
                      type="file"
                    />
                  </v-input>
                </ValidationProvider>
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-container>
            <v-layout
              align-center
              justify-center
              row
              wrap>
              <v-flex xs12>
                <v-textarea
                  :counter="true"
                  :error-messages="errors.collect('message')"
                  data-vv-name="message"
                  :label="$t('message.message')"
                  v-model="message"
                  v-validate="'required|max:240'"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="onClose"
          color="error"
          dark>
          {{ $t('message.close') }}
        </v-btn>
        <v-btn
          :disabled="sendingMessage"
          :loading="sendingMessage"
          @click="onSend"
          class="white--text"
          color="success">
          <span>{{ $t('message.send') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { BROADCAST_EVERYONE } from '../../store/modules/telegramBot/actions.type'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'broadcastMessage',
  components: {
    ValidationProvider
  },
  props: {
    dialog: {
      required: false,
      default: false
    },
  },
  data() {
    return {
      message: null,
      withImage: false,
      imageFile: null
    }
  },
  computed: {
    ...mapGetters({
      sendingMessage: 'sendingMessage'
    })
  },
  methods: {
    /*async broadcastMessage() {
      try {
        const valid = await this.$validator.validateAll()
        if (valid) {
          this.$store.dispatch(BROADCAST_MESSAGE, {
            text: this.message
          })
        }
      } catch (err) {
        console.error(err)
      }
    },
    async broadcastImage() {
      try {
        const valid = await this.$validator.validateAll()
        const validImage = await this.$refs.myInput.validate()

        if (valid && validImage) {
          this.$store.dispatch(BROADCAST_IMAGE, {
            text: this.message,
            image: this.imageFile
          })
        }
      } catch (err) {
        console.error(err)
      }
    },*/
    async broadcastEveryone() {
      try {
        const valid = await this.$validator.validateAll()
        if (valid) {
          this.$store.dispatch(BROADCAST_EVERYONE, {
            text: this.message
          })
        }
      } catch (err) {
        console.error(err)
      }
    },
    onClose() {
      this.$emit('update:dialog', false)
      this.message = null
      this.imageFile = null
      this.withImage = false
      this.$validator.reset()
      if (this.withImage) {
        this.$refs.myInput.reset()
      }
    },
    onSend() {
        if (this.withImage) {
            //this.broadcastImage()
        } else {
            this.broadcastEveryone()
        }
    },
    removeImage() {
      this.imageFile = null
      this.withImage = false
    },
    saveImage(imageFile) {
      if(imageFile.target.files[0]) {
        this.imageFile = imageFile.target.files[0]
        this.withImage = true
      }
    },
  }
}
</script>

<style scoped>
</style>
